var landscape = ['small', 'large'];
var leftmargin = ['margin1', 'margin2', 'margin3'];
var rightmargin = ['margin1', 'margin2', 'margin3', 'margin4', 'margin5', 'margin6'];
var portraitmargin = ['margin1', 'margin2', 'margin3', 'margin4', 'margin5', 'margin6', 'margin7', 'margin8', 'margin9'];

$( document ).ready(function() {
	//$('body').css('background','url('+ $('ul.frontpage').data('bgimg') +') no-repeat center center fixed');
	//$('body').css('background-size','cover');

	// zufällig reihenfolge der produkte
	$('.frontpage').randomize('li');
	
    getRandomSize();
    
    /* newsletter als zweites li element einfügen */
	$('ul.frontpage li:nth-child(1)').after('<li class="newsletter"><h1>Newsletter</h1><form target="_blank" action="https://wubet.us5.list-manage.com/subscribe/post" method="POST"><input type="hidden" name="u" value="996e116f03b935ac999b123e7"><input type="hidden" name="id" value="e8724cebe6"><label for="MERGE0">Email</label><input type="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value=""><button type="submit" class="subscribe">&nbsp;subscribe</button></form></li>');
    
    $('ul.frontpage li, ul.collections li').each(function(){
    	/* in linker oder rechter spalte */
    	var offset = $(this).offset();

	    if( offset.left < ( $(window).width() / 2 ) ){
	    	$(this).addClass('leftrow');
	    	if( $(this).hasClass('landscape') ){
	    		$(this).addClass( leftmargin[Math.floor(Math.random()*leftmargin.length)] );
	    	}
    	}
    	else{
    		$(this).addClass('rightrow');
	    	if( $(this).hasClass('landscape') ){
	    		$(this).addClass( rightmargin[Math.floor(Math.random()*rightmargin.length)] );
	    	}
    	}
    	
    	if(! $(this).hasClass('landscape') ){
	    	$(this).addClass( portraitmargin[Math.floor(Math.random()*portraitmargin.length)] );
    	}
    	
    	$(this).find('.outer').height( $(this).find('.image-wrap').height() );
    });
    
    // nach einer sekunde wird anordnung überprüft
    setTimeout(function() {
		// durch margin können sich lis noch verschieben, daher nochmal check auf welcher seite bild steht
	    checkRowPosition();
	}, 1500);

	if( $('video').length == 1) {
		$('video').get(0).play();
    }
    
    $('ul.frontpage .image-wrap a, ul.collections .image-wrap a').mouseenter(function(){
    	$(this).parents('li').find('.outer').height( $(this).parents('li').find('.image-wrap img').height() );
    	$(this).parents('li').find('.outer').height( $(this).parents('li').find('.image-wrap video').height() );
    	
	    $(this).find('img').css('opacity','0.5');
	    $(this).find('video').css('opacity','0.5');
	    $(this).find('.outer').css('display','table');
    }).mouseleave(function(){
    	$(this).find('img').css('opacity','1');
    	$(this).find('video').css('opacity','1');
	    $(this).find('.outer').css('display','none');
    });
    
    $( document ).on('click','.follow-us', function( event ){
    	event.preventDefault();
    	
    	if( $( '.socialbuttons li' ).css('visibility') == 'visible' ){ $( '.socialbuttons li' ).css('visibility', 'hidden'); }
    	else{ $( '.socialbuttons li' ).css('visibility', 'visible'); }
    });
    
    $( '#logo' ).click( function( e ) {
    	if( $('body').hasClass('template-index') ){
	    	getRandomSize();
	
		    e.preventDefault();
		    return false;
    	}
	});
});

$.fn.randomize = function(selector){
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function(){
        $(this).children(selector).sort(function(){
            return Math.round(Math.random()) - 0.5;
        }).remove().appendTo(this);
    });

    return this;
};

function arrangeFrontage(){
	
}

function getRandomSize(){
	$('ul.frontpage li, ul.collections li').each(function(){
    	if( $(this).find('img').height() > $(this).find('img').width() ){
    		$(this).removeClass('landscape');
	    	$(this).removeClass('small large margin1 margin2 margin3 margin4 margin5 margin6 margin7 margin8 margin9');
	    	
	    	$(this).addClass('portrait');
    	}
    	else{
	    	$(this).removeClass('portrait');
	    	$(this).removeClass('small large margin1 margin2 margin3 margin4 margin5 margin6 margin7 margin8 margin9');
	    	
	    	$(this).addClass('landscape');
	    	
	    	var size = landscape[Math.floor(Math.random()*landscape.length)];
	    	$(this).addClass( size );
	    	
	    	if( size == "large"){
	    		var mastersrc = $(this).find('img').data('master');
	    		$(this).find('img').attr('src', mastersrc);
	    	}
    	}
    });
    
    checkRowPosition();
}

function checkRowPosition(){
	$('ul.frontpage li, ul.collections li').each(function(){
    	/* in linker oder rechter spalte */
    	var offset = $(this).offset();
	    if( offset.left < ( ( $(window).width() / 2 ) - 1 ) ){
	    	$(this).removeClass('rightrow margin1 margin2 margin3 margin4 margin5 margin6');
	    	
	    	$(this).addClass('leftrow');
	    	$(this).addClass( leftmargin[Math.floor(Math.random()*leftmargin.length)] );
    	}
    	else{
    		$(this).removeClass('leftrow margin1 margin2 margin3 margin4 margin5 margin6');
    		
    		$(this).addClass('rightrow');
    		$(this).addClass( rightmargin[Math.floor(Math.random()*rightmargin.length)] );
    	}
    });
}